<div class="min-h-screen bg-gradient-to-br">
  <div class="container mx-auto px-4 py-8">
    <div class="text-center my-8">
      <app-page-title [titleKey]="'avis.title'"></app-page-title>
    </div>

    <app-children-selector
      [autoSelectFirst]="true"
      (studentSelected)="onStudentSelected($event)"
      (studentsLoaded)="onStudentsLoaded($event)"
    >
    </app-children-selector>
    <app-loader [isLoading]="loading"></app-loader>
    <div
      *ngIf="loading"
      class="col-span-full flex justify-center items-center py-12"
    >
      <div class="text-gray-500">{{ "avis.loadingNotices" | translate }}</div>
    </div>

    <div
      *ngIf="!loading && avis.length === 0"
      class="col-span-full flex justify-center items-center py-12"
    >
      <div class="text-gray-500">
        {{ "avis.noNoticesFound" | translate }}
        {{ selectedStudent?.nameStudent }}
      </div>
    </div>

    <div
      *ngIf="!loading && avis.length > 0"
      class="avislist grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8"
    >
      <div
        *ngFor="let avis of avis"
        class="bg-white rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer border border-gray-100 overflow-hidden"
        (click)="downloadAvis(avis)"
      >
        <div
          class="h-2"
          [ngClass]="{
            'bg-green-500': avis.vu === '1',
            'bg-[#62bebf]': avis.vu === '0',
          }"
        ></div>

        <div class="p-5">
          <div class="absolute top-4 right-4">
            <img
              src="assets/icons/pin-9.png"
              alt="Pin"
              class="w-8 h-8 object-contain"
            />
          </div>

          <div class="flex justify-center mb-4" style="margin-top: 10%">
            <h3
              class="font-bold text-gray-800 text-lg mb-2 text-center line-clamp-2 font-inter"
              [title]="avis.circularName"
            >
              {{ avis.circularName }}
            </h3>
          </div>

          <div
            class="flex items-center justify-between mt-4 pt-3 border-t border-gray-100"
          >
            <span
              class="text-base font-medium px-3 py-1 rounded-full"
              style="color: #f07d00"
            >
              📅 {{ avis.creationDate | date: "dd-MM-yyyy" }}
            </span>

            <button
              (click)="downloadAvis(avis); $event.stopPropagation()"
              class="flex items-center justify-center w-10 h-10 rounded-full bg-gray-50 hover:bg-blue-50 text-blue-500 hover:text-blue-700 transition-all duration-200 shadow-sm hover:shadow-md hover:scale-105"
              [title]="'common.download' | translate"
            >
              <svg
                width="20"
                height="20"
                [attr.fill]="'#F07D00'"
                viewBox="0 0 24 24"
                class="hover:fill-orange-600 transition-colors duration-200"
              >
                <path d="M12 16l-6-6h4V4h4v6h4l-6 6zm-8 2h16v2H4v-2z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="pagination-simple">
      <button
        (click)="previousPage()"
        [disabled]="currentPage === 1"
        class="btn-prev"
      >
        {{ "kissati.previous" | translate }}
      </button>

      <button
        *ngFor="let page of pageNumbers"
        (click)="goToPage(page)"
        [class.font-bold]="currentPage === page"
        class="px-3 py-2 hover:bg-[#65cac3] rounded transition-colors duration-200"
        style="border: 1px solid #65cac3"
      >
        {{ page }}
      </button>

      <button
        (click)="nextPage()"
        [disabled]="currentPage === totalPages"
        class="btn-next"
      >
        {{ "kissati.next" | translate }}
      </button>
    </div>
  </div>
</div>
